import { apiFetch } from './api';

export async function listTransactions({ page = 1, limit = 10, search = '', type = '', category = '' } = {}) {
  const params = new URLSearchParams();
  if (page) params.set('page', String(page));
  if (limit) params.set('limit', String(limit));
  if (search) params.set('search', search);
  if (type) params.set('type', type);
  if (category) params.set('category', category);
  const q = params.toString() ? `?${params.toString()}` : '';
  return apiFetch(`/api/admin/transactions${q}`);
}

export async function getTransaction(id) {
  return apiFetch(`/api/admin/transactions/${id}`);
}

export async function createTransaction(payload) {
  return apiFetch('/api/admin/transactions', { method: 'POST', body: payload });
}





